<template>
<div>
	<div
		v-if="display_revisions"
		class="hs-unfold-overlay"
		style="display: block;"
		@click.prevent="toggleRevisionsDisplay"
	/>
	<div
		v-if="display_revisions"
		class="hs-unfold-content sidebar sidebar-bordered sidebar-box-shadow
		hs-unfold-content-initialized hs-unfold-css-animation animated fadeInRight"
		style="width: 35rem; animation-duration: 300ms;"
		data-hs-target-height="0"
		data-hs-unfold-content=""
		data-hs-unfold-content-animation-in="fadeInRight"
		data-hs-unfold-content-animation-out="fadeOutRight"
	>
		<div class="card card-lg border-0 h-100 rounded-0">
			<div class="card-header">
				<div class="mr-2">
					<h3 class="card-header-title">
						Rebid Log
					</h3>
				</div>
				<a
					class="js-hs-unfold-invoker btn btn-icon btn-xs btn-ghost-dark"
					href="javascript:void(0);"
					@click.prevent="toggleRevisionsDisplay"
				>
					<i class="tio-clear tio-lg" />
				</a>
			</div>
			<div class="card-body activity-log-wrapper">
				<ul
					class="step"
					style=""
				>
					<BidRevision
						v-for="(revision, index) of revisionsWithDividers"
						:key="index"
						:revision="revision"
					/>
				</ul>
			</div>
		</div>
	</div>
</div>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import utilitiesMixin from '../../mixins/utilities';

import BidRevision from './bid-revision.vue';

export default {
	components: { BidRevision },
	mixins: [utilitiesMixin],
	computed: {
		...mapState('activeBid', ['display_revisions', 'revisions']),
		...mapGetters('activityLog', ['bidRevisions']),
		revisionsWithDividers() {
			const result = this.bidRevisions.map((item, index) => {
				const priorItem = this.bidRevisions?.[index - 1];
				const cdtxt = this.dateDiffForHumans(item.date, { addSuffix: true });

				if (priorItem) {
					const pdtxt = this.dateDiffForHumans(priorItem.date, { addSuffix: true });

					if (pdtxt !== cdtxt) {
						item.divider = cdtxt;
					}
				} else {
					item.divider = cdtxt;
				}

				return item;
			});

			return result;
		},
	},
	methods: {
		...mapActions('activeBid', ['toggleRevisionsDisplay']),
	},
};
</script>
<style scoped>
	.activity-log-wrapper {
		overflow-y: auto;
	}
</style>
